import dataModel from '../../models/DataModel.js';
import projectsService from '../../services/projectsService';
import AOCollection from './AOCollection.js';
import ReduxConstants from '../../constants/ReduxConstants.js';

export const projects_nav_root = {
  project: {
    location: {
    },
    project_contacts: { user: {} },users: {},
    additionalFields: [
      'tasks_count',
      'tasks_completed_count',
      'completion_steps_count',
      'completion_steps_completed_count',
    ],
  },
};

export default class FavoritesCollection extends AOCollection {
  
  constructor(userId, companyId, assigned, recordDescriptor) {
    super({
      name: ReduxConstants.FAVORITES,
      collectionType: ReduxConstants.PROJECT,
      userId,
      companyId,
      recordDescriptor,
    });
    this.assigned = assigned;
    this.processItemActionCable = this.processItemActionCable.bind(this);
  }
  
  static build(userId, companyId, assigned, recordDescriptor) {
    let collection = new FavoritesCollection(userId, companyId, assigned, recordDescriptor);
    let collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    if (!collectionData) {
      collectionData = collection.getDefaultData();
      collectionData = dataModel.collectionsDAO.setCollection(collection.getKey(), collectionData, collection.getCollectionType());
    }
    return collection;
  }

  handleOffLineFetch(options) {
    let denormalizedCollection = this.getDenormalizedCollection(options);
    return new Promise((resolve) => { 
      if (denormalizedCollection) {
        if (denormalizedCollection.projects && this._searchString) {
          denormalizedCollection.ids = [];
          const foundFavorites = denormalizedCollection.projects.filter(project => {
            if (project) {
              if (project.name.toLowerCase().indexOf(this._searchString.toLowerCase()) >= 0) {
                denormalizedCollection.ids.push(project.id);
                return true;
              }
              else {
                return false;
              }
            }
            return false;
          });
          denormalizedCollection.projects = foundFavorites;
          resolve(denormalizedCollection);
        }
        else {
          resolve(denormalizedCollection);
        }
      }
    });
  }

  async fetchCurrent(dummy, options, prefetchCallback) {
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      return new Promise(async (resolve) => {
        const serviceCall = projectsService.getFavorites.bind(this, null, {
          assigned: this.assigned, recordDescriptor:
            options && options.recordDescriptor ? options.recordDescriptor : projects_nav_root,
        });

        let newCollection = await this._fetchData(serviceCall, options, false, null, prefetchCallback);
        if (newCollection.offline) {
          return this.handleOffLineFetch(options);
        }
        newCollection.totalProjects = newCollection.meta ? newCollection.meta.total_projects : 0;
        return resolve (newCollection);
      });
    }
  }

  async processItemActionCable(updatedProject, acData, recordDescriptor) {
    return new Promise((resolve) => {
      const projectsCollection = this.getDenormalizedCollection({ recordDescriptor });
      if (acData.type == 'updateProject' && acData.sub_type == 'change_favorite') {
        if (updatedProject) {
          let found = false;
          projectsCollection.projects = projectsCollection.projects.map(proj => {
            if (proj.id == updatedProject.id) {
              found = true;
              return updatedProject;
            }
            else {
              return proj;
            }
          });
          if (!found) {
            projectsCollection.projects.push(updatedProject);
            projectsCollection.totalProjects++;
          }
          projectsCollection.totalRecords = projectsCollection.totalProjects;
          projectsCollection.ids = this.normalizeCollection(projectsCollection.projects, { store: true });
          dataModel.collectionsDAO.setCollection(this.getKey(), projectsCollection, this.getCollectionType());
          return resolve(this.getDenormalizedCollection({ recordDescriptor }));
        }
      }
      else if (acData.type == 'deleteProject') {
        let found = false;
        projectsCollection.locations = projectsCollection.locations.filter(proj => {
          if (proj.id != acData.location_id){
            return true;
          }
          else {
            found = true;
            return false;
          }
        });
        if (found) {
          projectsCollection.totalProjects--;
        }
        projectsCollection.totalRecords = projectsCollection.totalProjects;
        projectsCollection.ids = this.normalizeCollection(projectsCollection.locations, { store: true });
        dataModel.collectionsDAO.setCollection(this.getKey(), projectsCollection, this.getCollectionType());
        return resolve(this.getDenormalizedCollection({ recordDescriptor }));
      }
    });
  }

}
  



// WEBPACK FOOTER //
// ./src/dao/collections/FavoritesCollection.js